export const SAVER_SETTING_CAMPAIGN = "SAVER_SETTING_CAMPAIGN";
export const SAVER_SETTING_CAMPAIGN_RESPONSE =
  "SAVER_SETTING_CAMPAIGN_RESPONSE";
export const CHANGE_CAMPAIGN_DATA = "CHANGE_CAMPAIGN_DATA";
export const CLOSE_SAVER_BAR_SETTINGS = "CLOSE_SAVER_BAR_SETTINGS";
export const GET_CAMPAIGN_DATA_RESPONSE = "GET_CAMPAIGN_DATA_RESPONSE";
export const GET_CAMPAIGN_DATA = "GET_CAMPAIGN_DATA";
export const GET_SHOP_INFO = "GET_SHOP_INFO";

// get list teamplate shop
export const GET_LIST_TEMPLATE = "GET_LIST_TEMPLATE";
export const GET_LIST_TEMPLATE_RESPONSE = "GET_LIST_TEMPLATE_RESPONSE";

export const GET_SHOP_EMAIL = "GET_SHOP_EMAIL";
export const GET_SHOP_EMAIL_RESPONSE = "GET_SHOP_EMAIL_RESPONSE";

export const SEND_TEST_EMAIL = "SEND_TEST_EMAIL";
export const SEND_TEST_EMAIL_RESPONSE = "SEND_TEST_EMAIL_RESPONSE";

export const GET_LIST_CAMPAIGN_BY_TYPE = "GET_LIST_CAMPAIGN_BY_TYPE";
export const GET_LIST_CAMPAIGN_BY_TYPE_RESPONSE =
  "GET_LIST_CAMPAIGN_BY_TYPE_RESPONSE";
export const ACTIVE_DISABLE_CAMPAIGN = "ACTIVE_DISABLE_CAMPAIGN";
export const ACTIVE_DISABLE_CAMPAIGN_RESPONSE =
  "ACTIVE_DISABLE_CAMPAIGN_RESPONSE";
export const DELETE_CAMPAIGN = "DELETE_CAMPAIGN";
export const DELETE_CAMPAIGN_RESPONSE = "DELETE_CAMPAIGN_RESPONSE";
export const GET_DATA_DESIGN_SELECTED = "GET_DATA_DESIGN_SELECTED";
export const DATA_DESIGN_SELECTED_RESPONSE = "DATA_DESIGN_SELECTED_RESPONSE";

// price package
export const GET_CURRENT_PACKAGE = "GET_CURRENT_PACKAGE";
export const GET_CURRENT_PACKAGE_RESPONSE = "GET_CURRENT_PACKAGE_RESPONSE";
export const DOWNGRADE_PACKAGE = "DOWNGRADE_PACKAGE";
export const UPGRADE_PACKAGE = "UPGRADE_PACKAGE";
export const RESPONSE_DOWNGRADE_PACKAGE = "RESPONSE_DOWNGRADE_PACKAGE";
export const RESPONSE_UPGRADE_PACKAGE = "RESPONSE_UPGRADE_PACKAGE";

// ----

// setting shop info
export const GET_STORE_INFOMATION = "GET_STORE_INFOMATION";
export const GET_STORE_INFOMATION_RESPONSE = "GET_STORE_INFOMATION_RESPONSE";
export const CHANGE_STORE_INFOMATION = "CHANGE_STORE_INFOMATION";
export const SAVE_STORE_INFOMATION = "SAVE_STORE_INFOMATION";
export const SAVE_STORE_INFOMATION_RESPONSE = "SAVE_STORE_INFOMATION_RESPONSE";
// ----

// report
export const CALL_GET_LIST_LOGS_CAMPAIGN = "CALL_GET_LIST_LOGS_CAMPAIGN";
export const RESULT_GET_LIST_LOGS_CAMPAIGN = "RESULT_GET_LIST_LOGS_CAMPAIGN";
export const GET_DATA_COUNT_VIEW = "GET_DATA_COUNT_VIEW";
export const RESULT_GET_DATA_COUNT_VIEW = "RESULT_GET_DATA_COUNT_VIEW";
export const GET_STATIC_CHAR = "GET_STATIC_CHAR";
export const GET_STATIC_CHAR_RESULT = "GET_STATIC_CHAR_RESULT";

export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_RESULT = "GET_SETTINGS_RESULT";
